import { next } from '@ember/runloop';

import type { CustomPeriodPickerOptions } from 'webapp-types';

import type { Args as BaseArgs } from 'webapp/components/form/range/list-base';
import FormRangeListBaseComponent from 'webapp/components/form/range/list-base';
import FormRangeListItemComponent from 'webapp/components/form/range/list-item';

import DateRange from 'webapp/models-custom/date-range';
import type MetricLimitations from 'webapp/models-custom/metric-limitations';

interface Args extends BaseArgs {
	initialDateRange: DateRange;
	metricLimitations: MetricLimitations;
	exceptionIds: number[];
	customPeriodPickerOptions?: CustomPeriodPickerOptions;
}

export default class FormRangeListComponent extends FormRangeListBaseComponent<Args> {
	componentClass = FormRangeListItemComponent;

	get shownCategories() {
		const exceptionIds = this.args.exceptionIds || [],
			hideUnsupported = this.args.hideUnsupported;
		return this.args.metricLimitations.rangesByCategories.filter((item) => {
			// remove manually disabled, and also where all ranges are disabled (except if pricing limitation)
			return (
				!exceptionIds.includes(item.id) &&
				item.items.some((dateRange) => {
					return (
						!dateRange.isDisabled ||
						(!hideUnsupported && dateRange.isDisabledForPaymentReasons)
					);
				})
			);
		});
	}

	override setFirstSelected() {
		const selectedId = this.args.initialDateRange.rangeUISelectionId,
			exceptionIds = this.args.exceptionIds || [];

		if (selectedId) {
			const selectedItem = this.args.metricLimitations.ranges
				.filter((item) => {
					return !exceptionIds.includes(item.rangeCategoryId);
				})
				.find((item) => item.rangeUISelectionId === selectedId);

			if (selectedItem) {
				next(() => {
					selectedItem.updateRange(this.args.initialDateRange.rangeFormula);
					this.selectItem(selectedItem, true);
				});

				this.shownCategories.some((cat) => {
					return cat.items.some((item) => {
						if (item === selectedItem) {
							this.openCategoryId = cat.id;
							return true;
						}
						return false;
					});
				});
			}
		} else {
			this.openCategoryId = DateRange.Category.POPULAR;
		}
	}
}
